
export default () => `
  <div class="content">
    Attaching with Direct-To-Deck method, OSB or Plywood, 
    requires 2 additional #12-14x3" screws. Proper fastener will
    be included in BOM list. Fastener for the rafter will not appear 
    separately it is included with the attachment kit.
  </div>
`;
